if (window.Sentry) {
  Sentry.init({
    dsn: 'https://b914699ac410428291e919c39dd0bb10@o168020.ingest.sentry.io/5319441',
    environment: window.location.hostname
  });
}
